import { combine, withContext, withAsyncEffect } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import EventDetailsComponent from './component'

export default combine({
	hooks: [
		withContext('eventsStore', StoreContext, ({ events }) => events),
		withContext('tournamentsStore', StoreContext, ({ tournaments }) => tournaments),
		withAsyncEffect({
			deps: ['match.params.eventId'],
			dataName: 'event',
			loadingName: 'loading',
			errorName: 'error',
			async asyncAction({ eventsStore, tournamentsStore }, { match }) {
				try {
					const eventId = Number(match.params.eventId)

					// Try to load as tournament first, then fall back to event
					try {
						// Try loading as tournament
						const tournament = await tournamentsStore.loadOne(eventId)

						// Convert tournament data to event-like structure for compatibility
						return {
							id: tournament.id,
							tournament: tournament,
							tournamentName: tournament.tournamentName,
							startTime: tournament.startTime,
							endTime: tournament.endTime,
						}
					} catch (tournamentError) {
						console.warn('Failed to load event as tournament; falling back to event load:', tournamentError)
						// Fall back to loading as event
						const event = await eventsStore.loadOne(eventId)
						return event
					}
				} catch (error) {
					console.error('Failed to load event details:', error)
					throw new Error('Failed to load event details')
				}
			},
		}),
		withAsyncEffect({
			deps: ['event'],
			dataName: 'tournamentGames',
			loadingName: 'gamesLoading',
			errorName: 'gamesError',
			async asyncAction({ eventsStore, event }) {
				if (!event?.tournament?.id) {
					return []
				}

				try {
					// Use the same filters as the main games tab
					const currentDate = Date.now()

					// Load events for this tournament using same filters as main games tab
					const result = await eventsStore.load({
						tournamentId: event.tournament.id,
						size: 100, // Same as main games tab
						page: 0,
						sort: 'startTime,asc',
						startTimeEqOrGreater: currentDate, // Only get games from today onwards
						resolvedStatus: 'NOT_RESOLVED' // Only get unresolved games
					})

					return result?.events || []
				} catch (error) {
					console.error('Failed to load tournament games:', error)
					return []
				}
			},
		}),
	],
	transformProps: ({ event, loading, error, tournamentGames, gamesLoading, gamesError, match }) => ({
		event,
		loading,
		error,
		tournamentGames: tournamentGames || [],
		gamesLoading,
		gamesError,
		eventId: match.params.eventId,
	}),
})(EventDetailsComponent) 
